import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {TooltipCoordinator} from '../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface AiComposeRefineDropdownTooltipProps {
  title: ReactNode;
  tips: ReadonlyArray<{key: string; tip: ReactNode}>;
}

/*
 * Style.
 */

const StyledTooltipContainerDiv = styled.div`
  padding: 6px 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledTooltipTitleDiv = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.bold};
  line-height: 20px;
`;

const StyledTooltipBodyDiv = styled.div`
  font-size: ${fontSizes.verySmall};
  line-height: 18px;
`;

const StyledTooltipUl = styled.ul`
  margin: 0;
  padding-left: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

/*
 * Component.
 */

export const AiComposeRefineDropdownTooltip: FC<AiComposeRefineDropdownTooltipProps> = (props) => (
  <TooltipCoordinator
    placement="top"
    isMultiline
    maxWidth={300}
    render={() => (
      <StyledTooltipContainerDiv>
        <StyledTooltipTitleDiv>{props.title}</StyledTooltipTitleDiv>
        <StyledTooltipBodyDiv>
          <StyledTooltipUl>
            {props.tips.map(({key, tip}) => (
              <li key={key}>{tip}</li>
            ))}
          </StyledTooltipUl>
        </StyledTooltipBodyDiv>
      </StyledTooltipContainerDiv>
    )}
  />
);
